import { Reveal, ChapterTag } from "./Reveal";

const STEPS = [
    {
        nr: "01",
        title: "Kennenlernen",
        testid: "ablauf-step-1",
        text: "In einem kurzen unverbindlichen Gespräch lernen wir uns kennen und schauen, ob mein Angebot zu dir und deiner Situation passt.",
    },
    {
        nr: "02",
        title: "Beratung",
        testid: "ablauf-step-2",
        text: "Die Gespräche finden online per Video statt. Gemeinsam besprechen wir die Themen, die für dich gerade wichtig sind.",
    },
    {
        nr: "03",
        title: "Dein Weg",
        testid: "ablauf-step-3",
        text: "Du entscheidest gemeinsam mit mir, wie oft weitere Gespräche sinnvoll sind. Es gibt keine Verpflichtung zu einer bestimmten Anzahl von Sitzungen.",
    },
];

export const Ablauf = () => (
    <section id="ablauf" data-testid="ablauf-section" className="py-24 sm:py-32 lg:py-40 bg-[#F4F1EA]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
            <Reveal>
                <ChapterTag number="03" label="Ablauf" />
                <h2 className="font-serif font-light text-3xl sm:text-5xl tracking-tight text-[#2B2825]">
                    So funktioniert die Beratung
                </h2>
            </Reveal>

            <div className="mt-16 max-w-3xl">
                {STEPS.map((s, i) => (
                    <Reveal key={s.nr} delay={i * 0.12}>
                        <div
                            data-testid={s.testid}
                            className="group grid grid-cols-[64px_1fr] sm:grid-cols-[110px_1fr] gap-6 sm:gap-10 py-10 border-b border-[#DDD6C8] first:border-t"
                        >
                            <span className="font-serif font-light text-4xl sm:text-6xl text-[#C8C0B0] group-hover:text-[#7C6E5C] transition-colors duration-500 leading-none">
                                {s.nr}
                            </span>
                            <div>
                                <h3 className="font-serif font-medium text-2xl sm:text-3xl text-[#2B2825] mb-3">{s.title}</h3>
                                <p className="font-sans text-sm sm:text-base font-light leading-relaxed text-[#59534C] max-w-xl">{s.text}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
